export const GET_COUPON_BY_ID_REQUEST = 'GET_COUPON_BY_ID_REQUEST';
export const GET_COUPON_BY_ID_SUCCESS = 'GET_COUPON_BY_ID_SUCCESS';
export const GET_COUPON_BY_ID_FAIL = 'GET_COUPON_BY_ID_FAIL';
export const GET_COUPON_BY_ID_RESET = 'GET_COUPON_BY_ID_RESET';
export const SET_COUPON_SUCCESS = 'SET_COUPON_SUCCESS';
export const RESET_COUPON_NOTIFICATION = 'RESET_COUPON_NOTIFICATION';
